import apiCall from './apiRequest';
import endPoints from './endpoints';

export function refreshCompanyToken({ companyUUID, token }) {
    return apiCall({
        method: 'get',
        endpoint: endPoints.refreshCompany,
        authToken: token,
        query: `companyUUID=${companyUUID}`,
    });
}

export function fetchAdminInformationApi({ token }) {
    return apiCall({
        method: 'get',
        endpoint: endPoints.admin,
        authToken: token,
    });
}

export function logoutApi({ token }) {
    return apiCall({
        method: 'post',
        endpoint: endPoints.logout,
        authToken: token,
    });
}
